import { z } from "zod";

export const DeviceNameSchema = z.string().trim().min(1).max(80);
export const ConnectedDeviceSchema = z.object({
  id: z.string(),
  name: z.string(),
  platform: z.string().nullable(),
  online: z.boolean(),
  paired: z.boolean(),
  lastSeenAt: z.string().nullable(),
  agents: z.array(z.object({ id: z.string(), name: z.string(), installed: z.boolean() })),
});
export type ConnectedDevice = z.infer<typeof ConnectedDeviceSchema>;

export const DeviceAgentsSchema = z
  .array(z.object({ id: z.string().max(30), name: z.string().max(80), installed: z.boolean() }))
  .max(12);
export const DevicePairRequestSchema = z.object({
  code: z.string().regex(/^[a-f0-9]{64}$/),
  token: z.string().regex(/^[a-f0-9]{64}$/),
  platform: z.enum(["darwin", "win32", "linux"]),
});
export const DevicePollRequestSchema = z.object({
  active: z.array(z.string().max(100)).max(16),
  agents: DeviceAgentsSchema.optional(),
});
export const DeviceResultRequestSchema = z.object({
  id: z.string().max(100),
  seq: z.number().int().min(0).max(4095),
  frame: z.string().max(12 * 1024 * 1024),
});
